import { useEffect, useMemo, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

import getGreeting from 'utils/greeting';

import styles from './Greeting.module.scss';

interface GreetingProps {
  testId?: string;
  className?: string;
  firstName?: string;
}

const Greeting: React.FC<GreetingProps> = ({ testId = 'greeting', className, firstName }) => {
  const [isClient, setIsClient] = useState(false);

  const greeting = useMemo(() => {
    // Use real date-based greeting only after client hydration
    const now = new Date();
    return firstName ? `${getGreeting(now)}, ${firstName}` : `${getGreeting(now)}`;
  }, [firstName]);

  // Set client flag after hydration to prevent hydration mismatches
  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Box mb={2} className={className} data-testid={testId}>
      {isClient ? (
        <Typography variant="title2" component="h1" className={styles.headline}>
          {greeting}
        </Typography>
      ) : (
        <Skeleton
          variant="rectangular"
          width={firstName ? '280px' : '180px'}
          className={styles.skeleton}
        />
      )}
    </Box>
  );
};

export default Greeting;
